module.exports = __webpack_public_path__ + "static/media/globe.8fc92133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/globe.svg
// module id = 278
// module chunks = 0